import './MobileSideContentsCarousel.scss'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { first, includes } from 'lodash'

import useDeviceTypeContext from '../hooks/useDeviceTypeContext'

import CurationCarousel from './CurationCarousel'
import Loading from './Loading'
import SideContentsContainer from '../containers/SideContentsContainer'

import { DeviceType } from '../utils/responsive'

export default function MobileSideContentsCarousel() {
  const { t } = useTranslation()
  const deviceType = useDeviceTypeContext()

  const isMobile = includes([DeviceType.XS, DeviceType.SM, DeviceType.MD], deviceType)

  return isMobile ? (
    <section className="MobileSideContentsCarousel">
      <h2 className="screen-reader-text">{t('popularProgram.title')}</h2>
      <SideContentsContainer>
        {({ curations, isLoading }) => {
          const curation = first(curations)

          return (
            <>
              <Loading visible={isLoading} />
              {curation && (
                <CurationCarousel
                  isLoading={isLoading}
                  curation={curation}
                  linkQuerystring={`pos=rightSideBar_${curation.slug}`}
                />
              )}
            </>
          )
        }}
      </SideContentsContainer>
    </section>
  ) : null
}
